import {
  CssBaseline, StyledEngineProvider, ThemeProvider
} from "@mui/material";
import React, { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import GlobalStyles from "./GlobalStyles";
import { UserProvider } from "./logged_in/context/user.context";
import Pace from "./shared/components/Pace";
import ProtectedRoute from "./shared/components/ProtectedRoute";
import theme from "./theme";

const LoggedInComponent = lazy(() => import("./logged_in/components/Main"));

const LoggedOutComponent = lazy(() => import("./logged_out/components/Main"));

function App() {
  return (
    <>
      <Helmet>
        <meta name="twitter:site" content="@filler_ai" />
        <meta name="twitter:site" content="@Edmondthui" />
        <meta property="twitter:url" content="https://www.filler.ai/" />
        <meta
          property="twitter:title"
          content="Filler - AI generated content"
        />
        <meta
          property="twitter:description"
          content="Use the latest OpenAI technology to generate SEO content. Write articles, find keywords, and create video scripts in seconds."
        />
        <meta
          property="twitter:image:src"
          content="https://www.filler.ai/blogging.png"
        />
        <meta property="og:image:width" content="1280" />
        <meta property="og:image:height" content="640" />
        <meta property="twitter:card" content="summary_large_image" />

        <meta charSet="utf-8" />
        <meta
          name="title"
          property="og:title"
          content="Filler - AI generated content"
        />
        <meta
          property="og:image"
          content="https://www.filler.ai/blogging.png"
        />
        <meta
          name="description"
          property="og:description"
          content="Use the latest OpenAI technology to generate SEO content for your business. Create articles, find keywords, and video scripts in seconds."
        />
      </Helmet>

      <BrowserRouter>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <GlobalStyles />
            <Pace color={theme.palette.primary.light} />
            <Suspense fallback={<Fragment />}>
              <UserProvider>
                <Switch>
                  <ProtectedRoute path="/c" component={LoggedInComponent} />
                  <Route>
                    <LoggedOutComponent path="/" />
                  </Route>
                </Switch>
              </UserProvider>
            </Suspense>
          </ThemeProvider>
        </StyledEngineProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
